import React from 'react';
import SignIn from '../signin';

const Home = () => {
    return (
        <div className="bck_blue">
            <SignIn/>
           
        </div>
    );
};

export default Home;


// WEBPACK FOOTER //
// ./src/Components/home/index.js